import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationRequestService } from '@services/auth/authentication.request.service';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  errors = undefined;
  showErrors = false;

  pending = false;
  successful = false;

  token = undefined;

  form = new UntypedFormGroup({
    oldPassword: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    repeatPassword: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
  });

  constructor(
    private bus: BusService,
    private events: EventsService,
    private auth: AuthenticationService,
    private authReq: AuthenticationRequestService,
    private route: ActivatedRoute,
  ) {}

  get valid(): boolean {
    return (
      this.form.valid &&
      this.form.controls.password.value ===
        this.form.controls.repeatPassword.value
    );
  }

  submit() {
    if (!this.token) {
      this.auth.getCurrentUser.subscribe(user => {
        this.bus.publish(this.events.requested.action.user.changePassword, {
          userId: user._id,
          body: {
            oldPassword: this.form.controls.oldPassword.value,
            newPassword: this.form.controls.password.value,
          },
        });
      });
    } else {
      this.bus.publish(this.events.requested.action.user.changePassword, {
        userId: 'forgot',
        token: this.token,
        body: {
          oldPassword: this.form.controls.oldPassword.value,
          newPassword: this.form.controls.password.value,
        },
      });
    }

    this.pending = true;
  }

  get passwordsMatch() {
    if (
      this.form.controls.password.touched &&
      this.form.controls.repeatPassword.touched &&
      this.form.controls.password.value !==
        this.form.controls.repeatPassword.value
    ) {
      return false;
    } else {
      return true;
    }
  }

  get passwordsTooShort() {
    return (
      this.form.controls.password.touched &&
      this.form.controls.password.value.length < 8
    );
  }

  success() {
    this.pending = false;
    this.successful = true;
    this.showErrors = false;
  }

  failure(error) {
    this.pending = false;
    this.errors = error.message;
    this.showErrors = true;
  }

  ngOnInit() {
    this.subscribe();

    this.route.params.subscribe(params => {
      if (params.token) {
        this.token = params.token;
      }
      this.form.controls.oldPassword.setValidators([]);
    });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  subscribe() {
    this.bus.subscribe(
      this.events.received.action.user.changePassword.success,
      this.success,
      this,
    );
    this.bus.subscribe(
      this.events.received.action.user.changePassword.failure,
      this.failure,
      this,
    );
  }

  unsubscribe() {
    this.bus.unsubscribe(
      this.events.received.action.user.changePassword.success,
      this.success,
    );
    this.bus.unsubscribe(
      this.events.received.action.user.changePassword.failure,
      this.failure,
    );
  }
}
